// @flow strict

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {useSelector} from 'react-redux';
import {selectUserInfo} from 'src/selectors/crm';

import {
  PanelBody,
  PanelHeader,
} from '@spaced-out/ui-design-system/lib/components/Panel';

import {TypeAheadSelector} from 'src/components/crm/lib/typeAhead/typeahead.jsx';

import Evaluation from './evaluation.jsx';

import css from './on-behalf-evaluation.css';

// $FlowFixMe[signature-verification-failure]
const OnBehalfEvaluation = ({
  stepCandidate,
  step,
  sections,
  scorecard,
  onCancel,
  updateData,
}): React.Node => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  const {user: userInfo} = useSelector(selectUserInfo);
  const [reviewerId, setReviewerId] = React.useState(userInfo.id);
  const [reviewerName, setReviewerName] = React.useState(userInfo.username);

  const review =
    Array.isArray(stepCandidate.interviewReviews) &&
    stepCandidate.interviewReviews.find(
      (review) => review.reviewerId === reviewerId,
    );

  const checkIfReviewExists = (reviewerId) => {
    if (
      stepCandidate.interviewReviews.some(
        (review) => review.reviewerId === reviewerId,
      )
    ) {
      return true;
    }
    return false;
  };

  const [isViewMode, setViewMode] = React.useState(!!review);

  return (
    <PanelBody className={css.panelBody}>
      <div className={css.onBehalfOfUser}>
        <TypeAheadSelector
          label={t('Submit_on_behalf_of', 'Submit on behalf of')}
          isApiCall
          isUserSearch
          typeAheadOptions={[]}
          placeholder={t('Select_user', 'Select user')}
          onSelectOption={(selectedUsers) => {
            if (selectedUsers && selectedUsers.length > 0) {
              const selectedUser = selectedUsers[0];
              setReviewerId(selectedUser.key);
              setReviewerName(selectedUser.label);
              if (checkIfReviewExists(Number(selectedUser.key))) {
                setViewMode(true);
              } else {
                setViewMode(false);
              }
            } else {
              setReviewerId('');
              setReviewerName('');
              setViewMode(false);
            }
          }}
          selectedOption={
            Boolean(reviewerId) && Boolean(reviewerName)
              ? [
                  {
                    key: reviewerId ? reviewerId.toString() : '',
                    label: reviewerName ? reviewerName : '',
                  },
                ]
              : []
          }
          isSingleSelect={true}
          nonDismissibleChips={true}
        />
      </div>

      <Evaluation
        stepCandidate={stepCandidate}
        review={review}
        onBehalfOfUserId={reviewerId}
        sections={sections}
        scorecard={scorecard}
        step={step}
        onCancel={onCancel}
        isViewMode={isViewMode}
        setViewMode={setViewMode}
        updateData={updateData}
        jobId={stepCandidate.jobId}
        onBehalfOfUserId={reviewerId}
      />
    </PanelBody>
  );
};

export default OnBehalfEvaluation;
